@if (dialogObj?.Image) {
  <div class="c-survey__hero">
    <img src={{dialogObj.Image}} />
  </div>
}
<div class="c-survey__section c-splash-screen">
  <h2 id="greeting" class="c-survey__question">{{dialogObj.Title | translate}}</h2>
  <span id="surveyCompleted" style="text-align:left" [innerHTML]="dialogObj.Description | translate"></span>
</div>
